import type { DataProvider, Identifier } from "ra-core";

import type { Contact, Task } from "../types";

export type CompleteCampaignTaskOptions = {
  noteText?: string | null;
  identityId: Identifier;
  campaignName: string;
};

function buildPrefixedNote(
  campaignName: string,
  taskText: string,
  noteText: string,
) {
  return `[Campaign: ${campaignName} — ${taskText}]\n${noteText}`;
}

export async function completeCampaignTask(
  dataProvider: DataProvider,
  task: Task,
  options: CompleteCampaignTaskOptions,
) {
  const trimmedNote = options.noteText?.trim() ?? "";
  const now = new Date().toISOString();

  if (trimmedNote) {
    const prefixed = buildPrefixedNote(
      options.campaignName,
      task.text,
      trimmedNote,
    );

    if (task.contact_id) {
      const { data: contact } = await dataProvider.getOne<Contact>("contacts", {
        id: task.contact_id,
      });
      await dataProvider.create("contact_notes", {
        data: {
          contact_id: task.contact_id,
          text: prefixed,
          sales_id: options.identityId,
          date: now,
          status: contact?.status ?? "",
        },
      });
      if (contact) {
        await dataProvider.update("contacts", {
          id: task.contact_id,
          data: { last_seen: now },
          previousData: contact,
        });
      }
    } else if (task.company_id) {
      await dataProvider.create("company_notes", {
        data: {
          company_id: task.company_id,
          text: prefixed,
          sales_id: options.identityId,
          date: now,
        },
      });
    }
  }

  return dataProvider.update("tasks", {
    id: task.id,
    data: {
      done_date: now,
      completion_note: trimmedNote || null,
    },
    previousData: task,
  });
}
